import type { CountryCodes } from "../types/country-codes";

function getInCountryDisplayName(country: CountryCodes): string {
  if (country.iso3166Alpha2Lower === "us") {
    return "the United States";
  }

  return country.displayName;
}

export { getInCountryDisplayName };
